
export function BlogPostsSection() {
  const featuredPost = {
    title: 'Latest Smishing Scams Targeting UK Businesses in December 2024',
    excerpt: 'Discover the newest SMS phishing tactics criminals are using to target UK SMEs and learn how to protect your business from these sophisticated attacks.',
    author: 'Idris Ayoade',
    date: 'December 15, 2024',
    readTime: '8 min read',
    category: 'Latest Threats',
    image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&h=400&fit=crop&crop=center'
  };

  const posts = [
    {
      title: 'A 5-Step Cybersecurity Checklist for Every SME',
      excerpt: 'Essential security measures every UK small business should implement to protect against cyber threats.',
      author: 'Tommy Omonayajo',
      date: 'December 12, 2024',
      readTime: '6 min read',
      category: 'Security Tips',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop&crop=center'
    },
    {
      title: 'Phishing vs. Smishing: What\'s the Difference?',
      excerpt: 'Understanding the key differences between email and SMS-based attacks and how to defend against both.',
      author: 'Idris Ayoade',
      date: 'December 10, 2024',
      readTime: '5 min read',
      category: 'Security Tips',
      image: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=400&h=250&fit=crop&crop=center'
    },
    {
      title: 'Case Study: How a Manchester Bakery Avoided a £10,000 Scam',
      excerpt: 'Real-world example of how Driscop\'s AI protection saved a local business from a sophisticated phishing attack.',
      author: 'Driscop Team',
      date: 'December 8, 2024',
      readTime: '7 min read',
      category: 'Case Studies',
      image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400&h=250&fit=crop&crop=center'
    },
    {
      title: 'GDPR and Cybersecurity: What UK SMEs Need to Know',
      excerpt: 'Navigate the intersection of data protection regulations and cybersecurity requirements for your business.',
      author: 'Tommy Omonayajo',
      date: 'December 5, 2024',
      readTime: '9 min read',
      category: 'Compliance',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center'
    },
    {
      title: 'The Rise of AI-Powered Cyber Attacks in 2024',
      excerpt: 'How criminals are using artificial intelligence to create more sophisticated threats and how to defend against them.',
      author: 'Idris Ayoade',
      date: 'December 3, 2024',
      readTime: '10 min read',
      category: 'Industry News',
      image: 'https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=400&h=250&fit=crop&crop=center'
    },
    {
      title: 'Employee Training: Building Your Human Firewall',
      excerpt: 'Practical strategies for improving cybersecurity awareness among your team members.',
      author: 'Driscop Team',
      date: 'November 30, 2024',
      readTime: '6 min read',
      category: 'Security Tips',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400&h=250&fit=crop&crop=center'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Featured Post */}
          <div className="mb-16">
            <h2 className="text-2xl font-bold text-white mb-8">Featured Article</h2>
            <div className="bg-gray-800/50 rounded-xl overflow-hidden border border-gray-700">
              <div className="grid lg:grid-cols-2 gap-8">
                <div className="aspect-video lg:aspect-auto">
                  <img
                    src={featuredPost.image}
                    alt={featuredPost.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-8 lg:py-12">
                  <div className="flex items-center mb-4">
                    <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-medium">
                      {featuredPost.category}
                    </span>
                  </div>
                  <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                    {featuredPost.title}
                  </h3>
                  <p className="text-gray-400 mb-6 leading-relaxed">
                    {featuredPost.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="text-sm text-gray-500">
                        By {featuredPost.author} • {featuredPost.date} • {featuredPost.readTime}
                      </div>
                    </div>
                    <button className="text-blue-400 hover:text-blue-700 font-medium cursor-pointer">
                      Read More →
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Posts */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-8">Recent Articles</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((post, index) => (
                <article key={index} className="bg-gray-800/50 rounded-xl shadow-sm border border-gray-700 overflow-hidden hover:shadow-md transition-shadow">
                  <div className="aspect-video overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center mb-3">
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                        post.category === 'Security Tips' ? 'bg-blue-100 text-blue-800' :
                        post.category === 'Case Studies' ? 'bg-green-100 text-green-800' :
                        post.category === 'Compliance' ? 'bg-purple-100 text-purple-800' :
                        'bg-blue-500/20 text-blue-400 border border-blue-500/30'
                      }`}>
                        {post.category}
                      </span>
                    </div>
                    <h3 className="text-lg font-semibold text-white mb-3 line-clamp-2">
                      {post.title}
                    </h3>
                    <p className="text-gray-400 text-sm mb-4 line-clamp-3">
                      {post.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-gray-500">
                      <span>By {post.author}</span>
                      <span>{post.readTime}</span>
                    </div>
                    <div className="text-xs text-gray-500 mt-1">
                      {post.date}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          {/* Load More */}
          <div className="text-center mt-12">
            <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
              Load More Articles
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
